import React, {useEffect, useState} from 'react';

export default function GridImageList(props) {

    const [pageHeight, setPageHeight] = useState(0)

    useEffect(() => {
        setPageHeight(props.boxHeight * props.boxHeightOffset / 100 / 2)
    }, [props.boxHeight, props.boxHeightOffset])

    return (
        <div className="fullWidth allCenter">
            <div className="fullWidth">
                <div className="horizontalScreen fullWidth">
                    <img className="fullWidth" style={{height: pageHeight}} src={props.list[0].image}
                         onClick={() => {
                             props.onClicked(props.list[0])
                         }}
                         alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                    <img className="fullWidth" style={{height: pageHeight}} src={props.list[1].image}
                         onClick={() => {
                             props.onClicked(props.list[1])
                         }}
                         alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                </div>
            </div>

            <div className="fullWidth">
                <div className="horizontalScreen fullWidth">
                    <img className="fullWidth" style={{height: pageHeight}} src={props.list[2].image}
                         onClick={() => {
                             props.onClicked(props.list[2])
                         }}
                         alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                    <img className="fullWidth" style={{height: pageHeight}} src={props.list[3].image}
                         onClick={() => {
                             props.onClicked(props.list[3])
                         }}
                         alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                </div>
            </div>

        </div>
    )
}